// extracted by mini-css-extract-plugin
export var content = "styles-module--content--GP4-F";
export var buttons = "styles-module--buttons--E44VR";